import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"nut"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.50047 19.4996C7.62466 22.6238 13.0449 20.8545 16.9502 16.9493L15.536 15.5351L15.536 12.7067L12.7075 12.7067L7.05069 7.0498C3.14545 10.955 1.37627 16.3754 4.50047 19.4996Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M7.75748 4.92921C10.5627 2.12402 15.4914 3.99693 17.6094 6.29561C20.0051 8.51301 21.8959 13.4182 19.0712 16.2429L17.657 17.6571L15.5356 15.5358L15.5357 12.7074H12.7072L6.34326 6.34343L7.75748 4.92921Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.70955 7.3999C3.04464 11.2734 1.46814 16.4676 4.49998 19.4995C7.53393 22.5334 12.7332 20.9526 16.6076 17.2822","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.5996 6.28696C17.5562 6.24691 17.6287 6.31567 17.6146 6.30172M17.5996 6.28696C17.6027 6.28982 17.6058 6.2927 17.6089 6.29557M17.5996 6.28696C17.5646 6.25471 17.605 6.29285 17.6146 6.30172M17.6146 6.30172C17.6127 6.29967 17.6108 6.29762 17.6089 6.29557M17.6146 6.30172C17.6169 6.30386 17.6173 6.30444 17.6146 6.30172ZM17.6146 6.30172C18.2072 5.5781 19.0679 4.29516 19.4996 3M17.6146 6.30172C17.2366 6.76325 16.793 7.20664 16.2422 7.75736M17.6089 6.29557C15.4909 3.9969 10.5622 2.12399 7.75699 4.92918L6.34277 6.3434L12.7066 12.7068H15.5351V15.5352L17.6565 17.6571L19.0707 16.2429C21.8955 13.4181 20.0046 8.51297 17.6089 6.29557Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Nut = Vue.extend<IconProps>({
  name: 'NutIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'nut',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Nut;
